'use es6';

import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { jsx as _jsx } from "react/jsx-runtime";
const PermissionsError = () => {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    "data-test-id": "SidebarPermissionsError",
    illustration: "keys",
    illustrationProps: {
      width: 200
    },
    title: /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "universalSidebar.errors.PermissionsError.title"
      })
    }),
    paddingInline: "400",
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "universalSidebar.errors.PermissionsError.body"
      })
    })
  });
};
export default PermissionsError;